///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/directives/chart.ts" />

namespace TotalPoll {
    import Component = TotalCore.Common.Component;
    // @ts-ignore
    import ILocationService = angular.ILocationService;
    // @ts-ignore
    import RepositoryService = TotalPoll.RepositoryService;

    @Component('components.totalpoll', {
        templateUrl: 'insights-summary-component-template',
        bindings: {}
    })
    // @ts-ignore
    class InsightsSummaryComponent {
        public filters: any = {};
        public metrics: any = {};
        public processing = true;

        constructor(private RepositoryService: RepositoryService, private $location: ILocationService, private pollId: number) {
            this.filters.poll = pollId || null;
        }

        $onInit() {
            if (this.filters.poll) {
               this.loadMetrics();
            }
        }

        isProcessing() {
            return this.processing;
        }

        loadMetrics() {
            if (!this.filters.poll) {
                this.metrics = {};
                return false;
            }

            this.processing = true;
            this.RepositoryService
                .getMetrics(this.filters)
                .then((response) => {
                    this.processing = false;
                    this.metrics = response;

                    // @ts-ignore
                    angular.forEach(this.metrics.questions, (question, uid) => {
                        try {
                            this.metrics[uid]['options'] = {
                                options: {
                                    legend: {position: "bottom", align: "start", labels: { boxWidth: 16, padding: 8}},
                                    title: {display: false, "text": question['content'], position: "top", fontSize: 12}
                                }
                            };
                        } catch (e) {
                            console.log(e)
                        }
                    });
                })
                .catch((response) => {
                    if (confirm(`Something went wrong in the last operation (${response.status || ''} ${response.statusText || 'Unknown error'}). Retry?`)) {
                        this.loadMetrics();
                    }
                });
        }

    }
}
